import { JSONObject } from 'module/types/common';
import { Editor } from '@tiptap/core';
import { Slice } from '@tiptap/pm/model';
import { TextSelection } from '@tiptap/pm/state';
import { calculateFragmentDepth } from './node-utils';

export const getSelectionBetween = (
  editor: Editor,
  from: number,
  to: number,
) => {
  const $from = editor.state.doc.resolve(from);
  const $to = editor.state.doc.resolve(to);

  return TextSelection.between($from, $to);
};
export const getSelectionSlice = (editor: Editor, from: number, to: number) => {
  const selection = getSelectionBetween(editor, from, to);

  return editor.state.doc.slice(selection.from, selection.to, true);
};
export const getSelectionAsJSON = (
  editor: Editor,
  from: number,
  to: number,
): JSONObject[] => {
  const slice = getSelectionSlice(editor, from, to);

  return slice.toJSON().content;
};
export const getSliceFromJSON = (editor: Editor, json: JSONObject[]) => {
  const node = editor.schema.nodeFromJSON({
    type: 'doc',
    content: json,
  });
  const { openStart, openEnd } = calculateFragmentDepth(node.content);
  const slice = new Slice(node.content, openStart, openEnd);

  return slice;
};
